import React, { useState } from 'react'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import MultiMenuTooltip from '../MultiMenuTooltip'

const SendButton = (props) => {
  const { iconTypeName = 'send', optionsMenu = [], onClick, disabledSend = false, value='' } = props
  const [open, setOpen] = useState(false)

  const handleClickOptions = (isOpen) => {
    setOpen(isOpen)
  }

  const handleClickSend = () => {
    (typeof onClick === 'function' && !disabledSend) && onClick()
  }
  
  const noOptions = !optionsMenu.length ? 'noOptions' : undefined
  const classDisabled = disabledSend ? 'disabled' : ''
  return (
    <div 
      className={`
        send-button-container 
        ${noOptions && `send-button-container__${noOptions}`}
        ${disabledSend ? 'send-button-container--disabled' : ''}
      `}
      title={value}
    >
      <button 
        className={`send-button ${classDisabled}`} 
        onClick={handleClickSend}
        disabled={disabledSend}
      >
        <figure className={`send-button__icon ${noOptions && `send-button__icon--${noOptions}` }`}>
          <img
            src={getStaticImage(`/icons/orange-brand/icon-${iconTypeName}-primary-dark.svg`)}
            alt={iconTypeName}
          />
        </figure>
      </button>
      
      {optionsMenu.length ?
        <>
          <div className='send-button-container__separator'/>
          <MultiMenuTooltip 
            toggleButtonComponent={
              <div 
                className={`send-button-container__options`}>
                <i
                  className={`fa fa-chevron-${open ? 'up' : 'down'} send-button-container__options--icon`}
                  style={{ fontSize: '10px' }}
                />
              </div>
            } 
            options={optionsMenu}
            onChangeToggle={handleClickOptions}
            disabled={disabledSend}
          />
        </>
        : null
      }
      
    </div>
  )
}

export default SendButton